module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/15uL43D/tc-custom/9781446351079.jpg?1720120983952",
      "alt": "This image is the cover for the book Layer Cake, Jelly Roll and Charm Quilts"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Layer Cake, Jelly Roll and Charm Quilts\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Clever techniques for using precut fabric collections from the bestselling authors whose jelly roll books have sold over 300,000 copies!")]), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("Layer Cake, Jelly Roll and Charm Quilts")]), _vm._v(" provides seventeen beautiful projects that show readers how to get the most from their precut fabric bundles. The projects range from smaller lap quilts to full-sized bed quilts, and each is made from one jelly roll, layer cake, charm pack, or a combination, making the quilts quick and economical. Using the latest fabrics, the authors provide a main quilt and an alternative colorway for added versatility. Simple step-by-step instructions and illustrations make creating quilts from bundles accessible to quilters of all abilities."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Published with the support of Moda Fabrics.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Pam Lintott, Nicky Lintott\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    D&C\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0